import { Component, OnInit, TemplateRef, inject } from '@angular/core';
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";
import { APIService } from 'app/services/api.service';
import { AuthenticationService, reRgType } from 'app/services/auth.service';
import { NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { AdvisorContactComponent } from "app/modules/shared/advisor-contact.component";
import { styleType } from "app/components/Controls/NWMTable/NWMTable.component";
import { ExcelService } from "app/services/excel.service";
import { MenuComponent } from '../../../components/Controls/menu/menu.component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgTemplateOutlet, DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { AdvisorContactComponent as AdvisorContactComponent_1 } from '../../shared/advisor-contact.component';
import { MinusSignToParens } from 'app/pipes/minus-sign-to-parens.pipe';

type sortFieldType = 'ActivityDate' | 'ActivityStatus' | 'CharityName' | 'GrantAmountCAD' | 'DonationAmountCAD';
type dateRangeOptionType = {monthsRange: number, text: string};

export type activityType = {
  ActivityId: number;
  ActivityType: 'Grant' | 'Donation';
  ActivityDate: string;
  ActivityStatus: string;
  FundName: string;
  CharityId: number;
  CharityName: string;
  DonorName: string;
  CharityType: string;
  AmountCAD: number;
  AmountUSD: number;
  SpecialMessage: string;
  Designation: string;
  Note?: string;
  TransactionCurrency: string;
  GrantAmountCAD?: number;
  DonationAmountCAD?: number;
};

@Component({
    templateUrl: './activities.component.html',
    styleUrls: [`./activities.component.scss`],
    imports: [MenuComponent, FormsModule, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgClass, NgTemplateOutlet, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast, NgbTooltip, AdvisorContactComponent_1, MinusSignToParens, DecimalPipe, CurrencyPipe, DatePipe]
})

export class PgfActivitiesComponent implements OnInit {
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private excel = inject(ExcelService);
  private api = inject(APIService);
  auth = inject(AuthenticationService);
  modalService = inject(NgbModal);

  public reRg?: reRgType;
  public page = 1;
  public pageSize: number = this.config.document.documentPageSize;
  public pageOptions: number[] = Array.from({length: 10}, (v, k) => (k + 1) * 10);
  public totalPages = 1;

  public dateRange = -1;
  public dateRangeOptions: dateRangeOptionType[] = [
    {monthsRange: -1, text: 'All Time'},
    {monthsRange: 0, text: 'Year To Date'},
    {monthsRange: 1, text: 'Last Month'},
    {monthsRange: 3, text: 'Last 3 Months'},
    {monthsRange: 6, text: 'Last 6 Months'},
    {monthsRange: 12, text: 'Last 12 Months'}
  ];

  public sortField: sortFieldType = 'ActivityDate';
  public sortDir = 1;

  public dataList: activityType[] = [];
  public dataLoaded = false;
  public filteredData: activityType[] = [];
  public pagedData: activityType[] = [];

  public modalTitle = '';
  public modalAction: 'PgfDonation' | 'PgfGrant' | 'MessageAdvisor' = 'PgfGrant';

  public showDonations = true;
  public showGrants = true;
  public inceptionDonations = 0;
  public inceptionGrants = 0;
  public ytdDonations = 0;
  public ytdGrants = 0;

  ngOnInit() {
    this.loaderService.display(true, 'activities');

    this.reRg = this.auth.getCurrentReRg()!;
    this.dataLoaded = false;

    this.api.getPgfActivityByReRgId(this.reRg!.ReRgId).subscribe({
      next: res => {
        const year = ''+(new Date()).getFullYear();
        this.loaderService.display(false, 'activities');
        this.dataList = [];
        res.forEach(f=>{
          const row:activityType = {...f};
          if (row.ActivityType == 'Grant') {
            row.GrantAmountCAD = row.AmountCAD;
            this.inceptionGrants += row.AmountCAD;
            if (row.ActivityDate > year) this.ytdGrants += row.AmountCAD;
          } else {
            row.DonationAmountCAD = row.AmountCAD;
            this.inceptionDonations += row.AmountCAD;
            if (row.ActivityDate > year) this.ytdDonations += row.AmountCAD;
          }
          row.Note = '';
          if (f.Designation!=='') row.Note+= 'Designation: ' + f.Designation + '\n';
          if (f.SpecialMessage!=='') row.Note+= 'Special Message: ' + f.SpecialMessage;

          this.dataList.push(row);
        })
        this.filterData();
        this.dataLoaded = true;
      },
      error: () => this.loaderService.display(false, 'activities')
    });
  }

  filterData() {
    let startDate = '';
    const d = new Date();
    if (this.dateRange===0) {
      startDate = d.getFullYear() + '-01-01';
    }
    if (this.dateRange>0) {
      d.setMonth(d.getMonth() - this.dateRange);
      startDate = d.getFullYear() + '-' + (d.getMonth()+1).toString().padStart(2, '0') + '-' + d.getDate();
    }

    this.filteredData = this.dataList.filter(f =>
      (this.showGrants || f.ActivityType != 'Grant')
      && (this.showDonations || f.ActivityType != 'Donation')
      && (startDate=='' || f.ActivityDate >= startDate)
    )
    this.sortData();
    return true;
  }

  toggleSort(field: sortFieldType = 'ActivityDate') {
    if (this.sortField == field) {
      this.sortDir = 0-this.sortDir;
    } else {
      this.sortField = field;
      this.sortDir = 1;
    }
    this.sortData();
  }

  sortData() {
    if (this.sortField == 'CharityName') {
      this.filteredData.sort((a,b)=>
        a['CharityName'].localeCompare(b['CharityName'])*this.sortDir
      )
    } else {
      this.filteredData.sort((a,b)=>
        (a[this.sortField] || '') > (b[this.sortField] || '') ? 0-this.sortDir :
        (a[this.sortField] || '') < (b[this.sortField] || '') ? this.sortDir :
        a['CharityName'].localeCompare(b['CharityName'])
      )
    }
    this.setPage(1);
  }

  setPage(page: null | number = null) {
    if (page) this.page = page > 0 ? +page : 1;
    const l = this.filteredData.length;
    const p = this.pageSize>0 ? +this.pageSize : l;
    if (p<l) {
      this.totalPages = p ? Math.ceil(l / p) : 1;
      if (this.totalPages < this.page) this.page = this.totalPages;
      const s = (this.page-1) * p;
      const e = s+p > l ? l : s+p;
      this.pagedData = this.filteredData.slice(s, e);
    } else {
      this.totalPages = 1;
      this.pagedData = this.filteredData;
    }
  }

  openModalToContactAdvisor(content: TemplateRef<AdvisorContactComponent>, type: 'PgfDonation'|'PgfGrant'|'MessageAdvisor') {
    this.modalTitle = type == 'MessageAdvisor' ? 'Contact Advisory Team':
      type == 'PgfDonation' ? 'Request to Donate to Fund' :
      'Request to Send Grant to Charity';
    this.modalAction = type;
    this.modalService.open(content, { size: 'lg' })
  }

  export() {
    const headers = ["Date","Status","Charity","Donate to Fund","Grant to Charity","Designation","Special Message"];
    const lastCol = headers.length-1;

    const rows = [
      [(this.reRg!.ClientName || '') + ' - All Activities','','','','','', this.excel.toExcelLocalTime(new Date())],
      [],
      headers,
    ];
    this.filteredData.forEach(t => {
      rows.push([
        t.ActivityDate.split('T')[0],
        t.ActivityStatus,
        t.CharityName || 'Donation from ' + t.DonorName,
        t.ActivityType == 'Donation' ? t.AmountCAD : '',
        t.ActivityType == 'Grant' ? t.AmountCAD : '',
        t.Designation,
        t.SpecialMessage
      ]);
    });

    const styles: styleType[] = [
      // styles can be applied to row, col or cell, but if you do it more than once, only the latest will apply
      {col:0, width:15},
      {col:[3,4], align: 'R', width:20},
      {col:2, width:60},
      {col:[lastCol-1,lastCol], width:30},
      {row:0, col:lastCol, format: "m-d-yyyy h:mm:ss AM/PM", font:'10'},
      {row:2, height:30},
      {row:2, col:'0-'+lastCol, fill: "#183750", font: "Arial 10 #ffffff B", wrapText:1},
      {row:'3-'+rows.length,col:[3,4], format: '$#,##0.00;(#,##0.00);&quot;-&quot;'}
    ];

    this.excel.generate('PGFActivities.xlsx', [{sheetTitle:'All Activities', rows:rows, styles:styles}]);
  }
}
